<template>
  <v-app>
    <div id="app">


      <div class="container2">
        <!-- <LandingContent /> -->
        <router-view />
      </div>
    </div>
  </v-app>
</template>

<script>
//import LandingContent from "./components/Landing/LandingContent"
import Web3 from "web3";
import { mdiChevronDown } from "@mdi/js";
export default {
  //components: { LandingContent },
  name: "app",
  data() {
    return {
      icons: {
        mdiChevronDown,
      },
      trade: [
        {
          name: "Matching",
          link: "/matchingAdmin",
        },
        {
          name: "Offers",
          link: "/offersAdmin",
        },
        {
          name: "Requests",
          link: "/requestsAdmin",
        },
      ],
      portfolio: [
        {
          name: "Summary",
          link: "/summaryAdmin",
        },
        {
          name: "Assets",
          link: "/assetsAdmin",
        },
        {
          name: "Profile",
          link: "/profile",
        },
      ],
      help: [
        {
          name: "Tutorial",
          link: "/tutorial",
        },
        {
          name: "Support",
          link: "/support",
        },
      ],
      intelligence: [
        {
          name: "Pricing Intelligence",
          link: "/pricingIntelligence",
        },
        {
          name: "Forecasting",
          link: "/forecasting",
        },
      ],
    };
  },
  mounted() {
    window.Apps = this.Apps;
    window.addEventListener(
      "load",
      function () {
        if (window.ethereum) {
          // use MetaMask's provider
          this.Apps.web3 = new Web3(window.ethereum);
          window.ethereum.enable(); // get permission to access accounts
        } else {
          console.warn(
            "No web3 detected. Falling back to http://127.0.0.1:8545. You should remove this fallback when you deploy live"
          );
          // fallback - use your fallback strategy (local node / hosted node + in-dapp id mgmt / fail)
          this.Apps.web3 = new Web3(
            new Web3.providers.HttpProvider("http://127.0.0.1:8545")
          );
        }
        this.Apps.start();
      }.bind(this)
    );
  },

  computed: {
    getRoute() {
      return this.$route.fullPath;
    },
    getRole() {
      return this.$store.state.auth.user.roles.substring(5);
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    showAdminBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes("ROLE_ADMIN");
      }

      return false;
    },
    showModeratorBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes("ROLE_MODERATOR");
      }

      return false;
    },
    showUserBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes("ROLE_USER");
      }

      return false;
    },

    showTsoBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes("ROLE_TSO");
      }

      return false;
    },
    showDsoBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes("ROLE_DSO");
      }

      return false;
    },
    showFSPBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes("ROLE_FSP");
      }

      return false;
    },
  },
  methods: {
    logOut() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/login");
    },
  },
};
</script>

<style lang="scss">
@import "./sass/main.scss";

.landing-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
  width: 100%;
  background: #253858;
}

.inner-landing-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  width: 100%;
}

.dashboard-type {
  color: #fff;
}

.navbar-brand {
  display: flex;
  align-items: center;
}

.landing-bar-left {
  display: flex;
  align-items: center;
}

.nav-bar-links {
  display: flex;
  align-items: center;
}

.nav-bar-item {
  list-style: none;
}

.nav-logo {
  width: 150px;
  margin-right: 10px;
}

.nav-bar-link,
.nav-bar-link-active {
  color: $black;
  font-size: 1em;
  font-weight: 700;
  margin-left: 50px;
  padding: 10px 0;
  letter-spacing: 1.2px;
  position: relative;
  text-decoration: none;
}

.nav-bar-link:before,
.nav-bar-link-active:before {
  width: 0;
  position: absolute;
  content: "";
  left: 0;
  right: 0;
  bottom: 3px;
  height: 2px;
  background: $green;
  -webkit-transition: 0.15s linear;
  transition: 0.15s linear;
}

.nav-bar-link:hover {
  color: $black;
  text-decoration: none;
}

.nav-bar-link:hover:before,
.nav-bar-link-active:before {
  width: 100%;
}

.login-button {
  color: $black;
  margin: 0 20px;
}

.signin-button {
  color: #fff;
  background: $green2;
  padding: 10px 20px;
  border-radius: 20px;
  margin: 0 20px;
  font-weight: 700;
  letter-spacing: 1.2px;
}

.signin-button:hover {
  color: #fff;
  text-decoration: none;
  background: hsl(144, 58%, 40%);
}

.user-link {
  display: flex;
  align-items: center;
}

.profile-img {
  width: 40px;
  height: 40px;
  border-radius: 50px;
  margin: 0 10px;
}

.username {
  padding: 5px 0;
  color: #fff;
  font-size: 12px;
}

.flex {
  display: flex;
  align-items: center;
}

.role {
  color: #fff;
  font-size: 12px;
}

.dash-link {
  color: #fff;
  font-size: 14px;
  margin-right: 10px;
}
.landing-bar-middle {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.nav-menu-link {
  color: #fff !important;
  font-size: 0.9em;
  padding: 10px 0;
  letter-spacing: 1.2px;
  font-weight: 700;
  margin-right: 50px;
}

.landing-bar-middle .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: #f5f8fd !important;
}
</style>
